import { render, staticRenderFns } from "./Explosion.vue?vue&type=template&id=33d99da6&"
import script from "./Explosion.vue?vue&type=script&lang=js&"
export * from "./Explosion.vue?vue&type=script&lang=js&"
import style0 from "./Explosion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports